const mergeTimelineItems = (messages, pauseInterventions) => {
  const pendingMessages = messages.filter((message) => !message.createdAt).reverse();
  const datedItems = [
    ...messages.filter((message) => message.createdAt),
    ...pauseInterventions,
  ].sort((a, b) => a.createdAt.getTime() - b.createdAt.getTime());

  return [...datedItems, ...pendingMessages];
};

export default mergeTimelineItems;
